__turbopack_context__.v({
  "TableModule": "S8ukYW_TableModule",
  "TableModule__Caption": "S8ukYW_TableModule__Caption",
  "TableModule__RowHeader": "S8ukYW_TableModule__RowHeader",
  "TableModule__Table": "S8ukYW_TableModule__Table",
});
